export enum SysNonceTypes {
  ExternalPortalLogin = 1,
  ImpersonateClient = 2,
  ForgottenPassword = 3,
  OktaSso = 4,
  ImpersonateASF = 5,
}
